import React, { useRef } from 'react'
import {
	Box, Dialog, DialogContent, DialogTitle
} from '@mui/material'
import { ClassNameMap, withStyles } from '@mui/styles'
import stylesheet from '../detail-container.stylesheet'
import DialogTitleHeaderComponent from './dialog-title-header.component'
import Draggable from 'react-draggable'
import DiagnosisTestsComponent from '../diagnosis/diagnosis-tests.component'
import PatientClinicalInfoComponent from '../medications/patient-clinical-info.component'

interface IProps {
	open: boolean
	input: any
	handleConfirmClose: any
	classes: ClassNameMap
}

const TestStatusDialogComponent: React.FC<IProps> = ({ open, input, handleConfirmClose, classes }) => {
	const confirmRef = useRef(null) as any

	const getClinicalTeam = () => {

	}

	return (
		<Draggable ref={confirmRef} defaultPosition={{ x: 80, y: 20 }} handle='.test-status-dialog'>
			<Dialog
				id={`test-status-id`}
				fullWidth={true}
				maxWidth="sm"
				open={open}
				onClose={handleConfirmClose}
				hideBackdrop
				disableScrollLock
				sx={{ position: "absolute", left: '10rem', top: '0rem' }}
			>
				<DialogTitle className={classes.questionHeaderSection} classes={{ root: 'test-status-dialog' }}>
					<DialogTitleHeaderComponent title={input.title} handleDialogClose={handleConfirmClose} />
				</DialogTitle>
				<DialogContent className={classes.contextualHelpHeader} sx={{ padding: '0.5rem !important', backgroundColor: '#f0f1f2' }}>
					<Box mb={1}>
						{input.title === 'Clinical team'
							? <PatientClinicalInfoComponent
								input={{
									type: 'patient-list',
									clinical_team: input?.data || {}
								}} />
							: <DiagnosisTestsComponent
								input={{
									refId: input.refId,
									isPatientList: true
								}}
							/>
						}
					</Box>
				</DialogContent>
			</Dialog>
		</Draggable>
	)
}

export default withStyles(stylesheet)(TestStatusDialogComponent)